import { doMutation } from "../../core-module/util/graphqlHelper";
import { apolloClient } from "@/plugins/vue-apollo";
import { defaultPageInput } from "@/app/core-module/util/coreHelper";

const updateGetTrainingRegistrationInvoicesCache =
  trainingRegistrationInvoice => {
    try {
      if (trainingRegistrationInvoice) {
        const cacheKey = {
          query: require("../api/query/getTrainingRegistrationInvoices.gql"),
          variables: { pageInput: defaultPageInput(), filterInput: {} },
        };

        const cachedData = apolloClient.readQuery(cacheKey);

        if (cachedData?.getTrainingRegistrationInvoices) {
          const existingIndex =
            cachedData.getTrainingRegistrationInvoices.trainingRegistrationInvoices.findIndex(
              x => x._id === trainingRegistrationInvoice._id
            );

          if (existingIndex < 0) {
            cachedData.getTrainingRegistrationInvoices.trainingRegistrationInvoices.unshift(
              trainingRegistrationInvoice
            );
          }

          apolloClient.writeQuery({ ...cacheKey, data: cachedData });
        }
      }
    } catch (e) {
      // console.log(
      //   "generateTrainingRegistrationInvoice.updateGetTrainingRegistrationInvoicesCache:exception:",
      //   e.message
      // );
    }
  };

export const generateTrainingRegistrationInvoice = input => {
  const mutation = require("../api/mutation/generateTrainingRegistrationInvoice.gql");
  const variables = { input };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      updateGetTrainingRegistrationInvoicesCache(
        data.generateTrainingRegistrationInvoice
      );

      return { data: data.generateTrainingRegistrationInvoice };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
